import axios from "axios";
import configs from "../../../configs/config";
import { triggerAppAlert } from "../SelfServicePortal/ContactAid/ContactAid";
// import { triggerAppAlert } from "../SelfServicePortal/ContactAid/ContactAid";

const saveAssetUrl = `${configs?.BASE_URL}/CsvReport`;
export const saveAssetCSVReport = (name: string, filters: any, callback?: any) => {
    return async (dispatch: any) => {
      try {
        const payload = {
            "id":0,
            "name": name,
            "chartType": "CSV_ASSET" ,// "CSV_REPORT", //"CSV_ASSET ",
            "isActive": true,
            "filterValue": JSON.stringify(filters),
            "value": "",
        };
        const response = await axios.post(`${saveAssetUrl}`, payload);
        try{
          if(callback) callback(true,response?.data);
          dispatch(triggerAppAlert("Success! New Report Created", "success"));
        }catch(e:any){
          dispatch(triggerAppAlert("Report creation failed, Please try again!", "warning"));
          console.log('e')
        }
      } catch (error:any) {
          dispatch(triggerAppAlert("Report creation failed, Please try again!", "warning"));
        //   if(callback) callback(false,`${error?.response?.data || "Can you provide some extra details?"}`);
          return console.log(error);
      }
    };
  }
export const updateAssetCSVReport = (id: number|string,name: string, filters: any, callback?: any) => {
    return async (dispatch: any) => {
      try {
        const payload = {
            "id": id,
            "name": name,
            "chartType": "CSV_ASSET" , //"CSV_ASSET ",
            "filterValue": JSON.stringify(filters),
            "value": "",
        };
        const response = await axios.put(`${saveAssetUrl}/${id}`, payload);
        try{
          if(callback) callback(true,response?.data);
          dispatch(triggerAppAlert("Success! Report Updated", "success"));
        }catch(e:any){
          dispatch(triggerAppAlert("Report update failed, Please try again!", "warning"));

          console.log('e')
        }
      } catch (error:any) {
        //   if(callback) callback(false,`${error?.response?.data || "Can you provide some extra details?"}`);
          dispatch(triggerAppAlert("Report update failed, Please try again!", "warning"));

          return console.log(error);
      }
    };
  }

  export const GetAssetCSVreportsLazy = (
    pageNum: Number,
    isActive: boolean,
    search: string | null,
    callback: any,
    pageSize: number,
    assetName?: null | string,
    contactName?: null | string,
    assetType?: null | string,
    department?: null | string,
    assetTag?: null | string
  ) => {
    return async (dispatch: any) => {
      try {
        let searchVal = search ? `&search=${search}` : "";
        searchVal = assetName ? `${searchVal}&assetName=${assetName}` : searchVal;
        searchVal = contactName
          ? `${searchVal}&contactName=${contactName}`
          : searchVal;
        searchVal = assetType ? `${searchVal}&assetType=${assetType}` : searchVal;
        searchVal = assetTag ? `${searchVal}&assetTag=${assetTag}` : searchVal;
        searchVal = department
          ? `${searchVal}&department=${department}`
          : searchVal;
  
        let response = await axios.get(
          `${saveAssetUrl}/by-chart-type?chartType=CSV_ASSET`//&page=${pageNum}&count=${pageSize}&isActive=${isActive}${searchVal}`
        );
        console.log("getContactsLazy-e", new Date());
        if (callback)
          callback(
            pageNum,
            response.data,
            response.data.length === pageSize,
            response.data.totalCount
          );
        // if (pageNum === 0) {
          dispatch({
            type:"STORE_ASSETS_CSV_REPORT",
            payload:response.data,
          });
        // } 
        // else {
        //   dispatch({
        //     type:"",
        //     payload:response.data,
        //   });
        // }
      } catch (error: any) {
        console.log(error);
      }
    };
  };